export type QuestionAnswerSDMainEntityType = {
  '@type': string
  name: string
  acceptedAnswer: {
    '@type': string
    text: string
  }
}

export type QuestionAnswerSDType = {
  '@context': string
  '@type': string
  mainEntity: Array<QuestionAnswerSDMainEntityType>
}

const SPHERE_BASE_LOCATION = {
  location: {
    '@type': 'Place',
    name: 'Sphere',
    address: {
      '@type': 'PostalAddress',
      streetAddress: '255 Sands Ave. Las Vegas',
      addressRegion: 'NV',
      postalCode: '89169'
    }
  }
}

export const getEventStructuredData = (
  description: string = '',
  imageUrl: string = '',
  name: string = '',
  performerName: string = '',
  url: string = ''
) => ({
  '@context': 'http://schema.org',
  '@type': 'Event',
  ...(imageUrl && { image: imageUrl }),
  ...(url && { url: url }),
  ...(name && { name: name }),
  ...(description && { description: description }),
  ...(performerName && {
    performer: {
      '@type': 'Person',
      name: performerName
    }
  }),
  ...SPHERE_BASE_LOCATION
})

/**
 * Creates a dynmaic mapping of Content Heading => Paragraph for Structured Data (CHPSD).
 * @param data
 */
const createDynamicCHPSDMap = (data: object) => {
  const {
    content: {
      body: { blocks }
    }
  } = data

  const modules = blocks.filter(block => block.componentName === 'Module')
  const CHPSDMap: Array<QuestionAnswerSDMainEntityType> = []

  modules.forEach(module => {
    module.moduleSections.forEach(moduleSection => {
      const { blocks } = moduleSection
      const question = blocks.filter(block => block.componentName === 'ContentHeading')
      const answer = blocks.filter(block => block.componentName === 'Paragraph')

      if (question[0] && answer[0]) {
        CHPSDMap.push({
          '@type': 'Question',
          name: question[0].title,
          acceptedAnswer: {
            '@type': 'Answer',
            text: answer[0].text.html.replace(/(<([^>]+)>)/gi, '')
          }
        })
      }
    })
  })

  return CHPSDMap
}

const isEdpSlug = (pathname: string) => pathname.startsWith('/shows/') && pathname.split('/').length > 2

export const getStructuredDataBySlug = (slug: string, data?: any) => {
  const dynamicStructuredDataSlugs = ['/accessibility-services', '/faqs']

  if (!data) {
    console.warn(`Unable to find seeding data when creating structured data for ${slug}`)
    return {}
  }

  if (dynamicStructuredDataSlugs.indexOf(slug) !== -1) {
    return {
      '@context': 'https://schema.org',
      '@type': slug === '/faqs' ? 'FAQPage' : 'AccessbilityServicesPage',
      mainEntity: createDynamicCHPSDMap(data)
    }
  } else if (isEdpSlug(slug)) {
    const {
      eventStructuredDataDescription: description,
      eventStructuredDataImage: image,
      eventStructuredDataName: name,
      eventStructuredDataPerformerName: performerName
    } = data.content.body.seo || {}

    if (name) {
      return getEventStructuredData(description, image?.url, name, performerName)
    }
  }
}
